import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Users, FileText, CheckSquare } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { es } from 'date-fns/locale';

interface Activity {
  id: string;
  tipo: 'cliente' | 'mandato' | 'checklist';
  descripcion: string;
  fecha: string;
}

interface ActivityFeedProps {
  activities: Activity[];
}

export const ActivityFeed = ({ activities }: ActivityFeedProps) => {
  const getIcon = (tipo: Activity['tipo']) => {
    switch (tipo) {
      case 'cliente':
        return <Users className="h-4 w-4" />;
      case 'mandato':
        return <FileText className="h-4 w-4" />;
      case 'checklist':
        return <CheckSquare className="h-4 w-4" />;
    }
  };

  const getBadgeVariant = (tipo: Activity['tipo']) => {
    switch (tipo) {
      case 'cliente':
        return 'default';
      case 'mandato':
        return 'secondary';
      case 'checklist':
        return 'outline';
    }
  };

  const getBadgeText = (tipo: Activity['tipo']) => {
    switch (tipo) {
      case 'cliente':
        return 'Cliente';
      case 'mandato':
        return 'Mandato';
      case 'checklist':
        return 'Checklist';
    }
  };

  return (
    <Card className="col-span-3">
      <CardHeader>
        <CardTitle>Actividad Reciente</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {activities.map((activity) => (
            <div key={activity.id} className="flex items-center space-x-4">
              <div className="flex-shrink-0">
                {getIcon(activity.tipo)}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium truncate">
                  {activity.descripcion}
                </p>
                <p className="text-xs text-muted-foreground">
                  {formatDistanceToNow(new Date(activity.fecha), { 
                    addSuffix: true, 
                    locale: es 
                  })}
                </p>
              </div>
              <Badge variant={getBadgeVariant(activity.tipo)}>
                {getBadgeText(activity.tipo)}
              </Badge>
            </div>
          ))}
          {activities.length === 0 && (
            <p className="text-sm text-muted-foreground text-center py-4">
              No hay actividad reciente
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};